export const ACTIVE_DAG_RUN_STATUSES = ['queued', 'running'];

export const DEFAULT_DAG_LOG_POLL_INTERVAL_MS = 30000;

export function hasActiveDagRuns(metadata) {
    return Array.isArray(metadata) && metadata.some(
        (run) => ACTIVE_DAG_RUN_STATUSES.includes(String(run.status ?? '').toLowerCase())
    );
}
